import React, { useEffect } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom'; // useLocation

import {
  // ADDRESS_ROUTE,
  CHECKOUT_ROUTE,
  ERROR_PAGE_ROUTE,
  FAIL_PAGE_ROUTE,
  FORBIDDEN_ROUTE,
  GET_CS_OTP_RESULT,
  GET_NEW_PAYMENT_STATUS_ROUTE,
  // GET_PAYMENT_STATUS_ROUTE,
  GET_TOKEN_ROUTE,
  HOME_ROUTE,
  // PIN_ROUTE,
  SUCCESS_PAGE_ROUTE,
} from '~/routing/routes';
import Home from '~/pages/home/Home';
import GetToken from '~/pages/getToken/GetToken';
import SuccessPage from '~/pages/successPage/SuccessPage';
import FailPage from '~/pages/failPage/FailPage';
import GetPaymentStatus from '~/pages/getPaymentStatus/GetPaymentStatus';
import ErrorPage from '~/pages/errorPage/ErrorPage';
import Login from '~/pages/login/Login';
import PrivateRoute from '~/routing/PrivateRoute';
import CardCheckoutPage from '~/components/forms/CheckoutPage/CheckoutPage';
import GoogleAnalytics from '~/services/GoogleAnalytics';
import ValidatePayment from '~/pages/validatePayment/ValidatePayment';

// TO DO:  Refact this component, protect main home page with PrivateRoute, move sidebar, header from home to here

const Router: React.FC = () => {
  useEffect(() => {
    GoogleAnalytics(window.location.pathname + window.location.search);
  }, []);

  // const location = useLocation();

  return (
    <BrowserRouter>
      <Switch>
        <Route exact path={FORBIDDEN_ROUTE()} component={Login} />
        <PrivateRoute exact path={HOME_ROUTE()} component={Home} />
        <PrivateRoute exact path={CHECKOUT_ROUTE} component={CardCheckoutPage} />
        <Route exact path={GET_TOKEN_ROUTE()} component={GetToken} />
        <PrivateRoute exact path={SUCCESS_PAGE_ROUTE()} component={SuccessPage} />
        <PrivateRoute exact path={FAIL_PAGE_ROUTE()} component={FailPage} />
        <Route exact path={GET_NEW_PAYMENT_STATUS_ROUTE()} component={GetPaymentStatus} />
        {/* GET_PAYMENT_STATUS_ROUTE */}
        <Route exact path={ERROR_PAGE_ROUTE()} component={ErrorPage} />
        {/* <Route exact path={PIN_ROUTE()} component={} />
        <Route exact path={ADDRESS_ROUTE()} component={} /> */}
        <Route exact path={GET_CS_OTP_RESULT()} component={ValidatePayment} />
      </Switch>
    </BrowserRouter>
  );
};

export default Router;
